import { StringId } from '../localizer/stringId'

export const strings = {
    [StringId.DV_DP_EL_episode_title_template]: '{sequenceNumber}. {episodeTitle}',
    [StringId.DV_DP_EL_bonus_title_template]: 'Bonus: {episodeTitle}',
    [StringId.DV_comma_separator]: ', ',
}
